import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { H3_TITLE } from '@Apis/constants';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import PurchaseRequestsList from './PurchaseRequestsList';
import './style.scss';
/**
 *
 */
class PurchaseRequestsHome extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{H3_TITLE}</title>
        </Helmet>
        <div className="org-wrapper">
          <PurchaseRequestsList />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = () => ({

});

PurchaseRequestsHome.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseRequestsHome));
